import { useNavigate } from 'react-router-dom';

function PoliticianCard({ politician }) {
    const navigate = useNavigate();

    const getHealthColor = (score) => {
        if (score >= 80) return '#2ECC71';
        if (score >= 60) return '#F39C12';
        return '#E74C3C';
    };

    const getPartyColor = (party) => {
        switch (party) {
            case 'Democrat': return '#4A90E2';
            case 'Republican': return '#E74C3C';
            case 'Independent': return '#95A5A6';
            default: return '#7F8C8D';
        }
    };

    const handleCardClick = () => {
        navigate(`/politician/${politician.id}`);
    };

    return (
        <div className="politician-card" onClick={handleCardClick}>
            <img
                src={politician.image}
                alt={politician.name}
                className="politician-image"
            />

            <div className="politician-info">
                <h3 className="politician-name">{politician.name}</h3>

                <div
                    className="politician-party"
                    style={{ backgroundColor: getPartyColor(politician.party) }}
                >
                    {politician.party}
                </div>

                <div className="politician-details">
                    <p><strong>Age:</strong> {politician.age}</p>
                    <p><strong>Years in Office:</strong> {politician.yearsInOffice}</p>
                    {politician.state && <p><strong>State:</strong> {politician.state}</p>}
                    {politician.district && <p><strong>District:</strong> {politician.district}</p>}
                    {politician.position && <p><strong>Position:</strong> {politician.position}</p>}
                </div>

                <div className="health-score">
                    <span>Health Score: </span>
                    <span
                        className="score-badge"
                        style={{ backgroundColor: getHealthColor(politician.healthScore) }}
                    >
                        {politician.healthScore}
                    </span>
                </div>
            </div>

            <div className="card-overlay">
                <span>Click for details →</span>
            </div>
        </div>
    );
}

export default PoliticianCard;